'use client';
import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import styles from './style.module.scss';

const SeoTextToggle = ({ text }: { text?: string; className?: string }) => {
  const [showMore, setShowMore] = useState(false);
  const { t } = useTranslation(['common']);
  if (!text) return null;

  return (
    <div className={'mb-2'}>
      <div
        dangerouslySetInnerHTML={{ __html: text && text.replaceAll('[break]', '<br>') }}
        className={`${styles['brandSeo']} seo-text`}
        style={{
          whiteSpace: 'pre-wrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: showMore ? 'unset' : 3,
          WebkitBoxOrient: 'vertical',
        }}
      />
      <div className={'d-flex justify-content-start cursor-pointer'} onClick={() => setShowMore(!showMore)}>
        {!showMore ? (
          <span className={styles['showText']}>{t('SHOW_MORE')}</span>
        ) : (
          <span className={styles['showText']} style={{ marginTop: '-1rem' }}>
            {t('SHOW_LESS')}
          </span>
        )}
      </div>
    </div>
  );
};

export default SeoTextToggle;
